// This directive shows and hides stuff based on the merchantInfo, it should do no more than that.
angular.module('qkr').factory('merchantInfoTraitService', (merchantService) => {

    const checkTrait = (traits, merchantInfo) => {
        const splitTraits = traits.split(/\s+/); // split on ws

        // If adding a new custom trait:
        // 1. Ensure the words are lowercase and all a-z
        // 2. You may use hyphen separators
        // 3. Three words max

        const rules = {
            accountancy: !!merchantInfo.accountancyPackage,
            perk: merchantInfo.creditPerkRedemptionEnabled,
            "is-pos": merchantInfo.merchantPosProperties ? merchantInfo.merchantPosProperties.posType : false
        };

        // if ANY string matches either a rule or the merchant business category then permission is granted
        return splitTraits.find(trait => rules[trait] ? rules[trait] :
            trait === merchantInfo.businessCategory.name.toLowerCase()
        );
    };

    return {
        hasTraits(traits){
            return new Promise((resolve, reject) => {
                if (merchantService.merchantInfo){
                    resolve(checkTrait(traits, merchantService.merchantInfo));
                }
                else {
                    resolve(
                        merchantService.loadCacheableMerchantResponse()
                            .then(merchantInfo => checkTrait(traits, merchantInfo)));
                }
            });
        },
    }

});




// WEBPACK FOOTER //
// ./src/shared/merchantInfoTrait.service.js